<template lang="pug">
    app-card
      app-card-header 
        v-row.flex-nowrap(no-gutters align="baseline")
          .col-auto.sud-case-status-color.mr-2(v-bind:style="{ background: statusColor(advocatApp.appStatus) }")
          .col.ml-2(v-line-clamp="1") {{ advocatApp.appStatus.title }}
          .col-auto.text-no-wrap {{ shortDate(advocatApp.createDate) }}
      app-card-body
        app-card-caption Общий счет на оплату: 
          strong {{ advocatApp.summa }} руб.
        app-card-caption
          | подзащитный 
          strong {{ advocatApp.caseMember.persona.personaType.value==1?advocatApp.caseMember.persona.orgName:advocatApp.caseMember.persona.name}}
          br
          div(v-if="fromAdvocat")
            | судья 
            strong {{ fullName(advocatApp.courtCase.judge, 'judge')}}
          div(v-else)
            | {{ advocatApp.specialist.specialistType.title }} 
            strong {{ fullName(advocatApp.specialist, 'member') }}
        app-card-caption Текущий статус заявки: 
          strong {{ advocatApp.appStatus.title }}
            span(v-if="advocatApp.judgeSig && advocatApp.judgeSig!=''")  (Подписана)
        hr
        slot

</template>

<script>
import moment from 'moment'
moment.locale('ru');
import AppStatuses from "@/assets/data/SpecAppStatuses.json"

export default {
  props: {
    advocatApp: null,
    fromAdvocat: {
        default:true,
        type:Boolean
    }
  },
  methods: {
    shortDate(date) {
      return moment(date).format("DD.MM.YYYY")
    },
    statusColor(status) {
      if (status.color > 0 && status.color < 4) {
        return AppStatuses.colors[status.color]
      }
      return '#000'
    },
    fullName: (pers, type) => {
      if(type=="judge")
        return pers.lastName+" "+pers.firstName+" "+pers.middleName
      else if(type=="member")
        return pers.persona.personaType.value==1?pers.persona.orgName:pers.persona.name
      else 
        return pers.name
    }
  },
}
</script>

<style lang="scss" scoped>

</style>

